import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";


const styles = createUseStyles(theme => ({
  list: {
    "&:focus":{
      border: '2px solid red'
    },
    listStyleType: "none",
    padding: "0 16px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "0 8px",
      backgroundColor: theme.navigation.mobile.backgroundColor,
      overflow: "auto",
      marginBottom: "8px",
    },
    marginBottom: "24px",
    "& li": {
      borderRadius: "4px",
      margin: "4px 0",
      "& :focus-visible":{
        boxShadow: "0px 0px 0px 4px " + colors.lightBlue
      },
      "&:hover:not(.active)": {
        cursor: "pointer",
        backgroundColor: theme.navigation.li.active.backgroundColor,
        "& a":{
          color: theme.navigation.li.hover.color,
        },
      },
      "& a": {
        display: "flex",
        width: "100%",
        textDecoration: "none",
        color: theme.navigation.li.default.color,
        padding: "8px 12px",
        alignItems: "center"
      },
      "&.active": {
        cursor: "default",
        backgroundColor: theme.navigation.li.active.backgroundColor,
        "& a": {
          color: theme.navigation.li.active.color,
        }
      },
      "&.disabled": {
        pointerEvents: "none",
        backgroundColor: theme.navigation.li.disabled.backgroundColor,
        "& path": {
          stroke: theme.navigation.li.disabled.color
        },
        "& a": {
          color: theme.navigation.li.disabled.color,
        }
      },
      "& :focus:not(.focus-visible)":{
        outline:"none",
      },
    }
  },
  iconContainer : {
    marginRight: "12px",
    width: "25px",
  },
  iconActive: {
    "& path": {
      stroke: theme.navigationIcon.hover.stroke
    }
  },
  icon: {
    "& path": {
      stroke: theme.navigationIcon.stroke
    }
  },
  totalPeople:{
    color:  theme.text.themeColor.color,
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    backgroundColor: theme?.tabs?.numberBadge?.backgroundColor || colors.primary50Blue,
    marginBottom: 0,
    marginLeft: "6px",
    padding: "2px 8px 1px 8px",
    borderRadius: "16px"
  },
  navigationLanbe: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between"
  }
}));

export default styles;